import Util from './util';
import ApiLocal from './api/local';
import Notification from './notification';
import Nodes from './config/nodes';
import Template from './template';
import MasterData from './config/master-data';
import Lang from './lang';
import Config from './config/index';
import Log from './log';
import Bill from './bill';
import Spinner from './spinner';

function serialize() {
    let els = Nodes.el.designerDesk.children();
    let serialized = [];

    if (!els || !els.length) return Notification.show(Lang.get('save.noItems'), 'error');

    els.each((index, el) => {
        let $el = $(el),
            productId = $el.data('product-id'),
            rotated = $el.data('rotated'),
            sisal = $el.data('sisal'),
            transform = $el.css('transform'),
            transformSplit = transform.split(', ').map((val) => {
                let parsed = 0;
                try {
                    parsed = parseFloat(val);
                } catch (e) {
                }
                return Util.isNumber(parsed) ? parsed : 0;
            }),
            x = transformSplit[4],
            y = transformSplit[5];

        serialized.push({
            id: productId,
            x,
            y,
            rotated,
            sisal,
        });
    });

    return {
        config: getModelConfig(),
        elements: serialized
    };
}

function getModelConfig() {
    let config = {color: {}};
    //['wood', 'shutter', 'pillow'].forEach((name) => {
    ['wood', 'pillow'].forEach((name) => {
        config.color[name] = $(`#color-${name}`).parent().find('.select__val').text().trim();
    });
    config.ceilHeight = $('#ceil-height').val();
    return config;
}

function setModelConfig(config) {
    //['wood', 'shutter', 'pillow'].forEach((name) => {
    ['wood', 'pillow'].forEach((name) => {
        $(`#color-${name}`).parent().find(`:contains(${config.color[name]})`).trigger('click');
    });
    $('#ceil-height').val(config.ceilHeight);
}

function save(notify = true) {
    Spinner.show();

    // elements
    let serialized = btoa(JSON.stringify(serialize()));

    const locationSegments = location.pathname.split('/');
    const baseId = locationSegments.length >= 2 ? locationSegments[locationSegments.length - 2] : null;
    const action = Util.isNumber(baseId) ? 'kratzbaum.addVersion' : 'kratzbaum.create';

    let promise = ApiLocal.query(action, {kratzbaum: {serialized}}, {base_id: baseId});
    promise.then((data) => {
        Log.trace('success', data);
        if(notify) {
            Spinner.hide();
            Notification.show('Saved successfully', 'success');
        }
        updateURL(data);
    }).catch((err) => {
        Spinner.hide();
        Log.error(err);
    });

    return promise;
}

Template.add('designer.article', `
    <div class="inventory__img dd--dragitem dd--draggable dd--dragged {{cls}}"
        data-product-id="{{id}}" 
        data-rotated="{{rotated}}"
        data-sisal="{{sisal}}"
        style="transform: translate({{x}}px, {{y}}px);">
        
        <img src="{{img}}" draggable="false" alt="designer image">
    </div>
    `);

function load() {
    let locationSegments = location.pathname.replace(/^\/+|\/+$/gm, '').split('/');  // remove slashes at beginning and end and split resulting string
    if (locationSegments.length < 2) return Log.trace('[model-loader] not loading: Not enough params') & Spinner.hide();
    let base_id = locationSegments[locationSegments.length - 2],
        version = locationSegments[locationSegments.length - 1];
    if (!Util.isNumber(base_id) || !Util.isNumber(version)) return Log.trace('[model-loader] not loading: `base_id` or `version` is not a number') & Spinner.hide();

    ApiLocal.query('kratzbaum.get', null, {base_id, version}).then((data) => {
        if(Util.isArray(data)) data = data [0];
        let asBase64 = data.serialized;
        let asString = atob(asBase64);
        let model = Util.tryJsonParse(asString);
        let serialized = model.elements;
        if (!serialized || !serialized.length) return;

        setModelConfig(model.config);

        let html = serialized.reduce((html, item) => {
            let product = MasterData.products[item.id];
            if (!product) return html;

            // set item img
            item.img = item.rotated ? product.img.rotated : product.img.designer;

            let cls = '';
            if (item.sisal) cls += ' designer__item_sisal';
            if (item.rotated) cls += ' designer__item_rotated';
            item.cls = cls;

            // add item to bill
            Bill.add(item.id);
            if (item.sisal) Bill.add(Config.idSisal);
            return html + Template.fill('designer.article', item);
        }, '');

        Nodes.el.designerDesk.html(html);
        Spinner.hide();
        Notification.show(Lang.get('load.success'), 'success');
        Bill.render();
    }).catch((err) => {
        Log.error('ERROR WHILE LOADING MODEL:', err);
        updateURL(null);
        Spinner.hide();
        Notification.show(Lang.get('load.error'), 'error');
    });
}

function updateURL(data) {
    if (Util.isNull(data) || Util.isNull(data.base_id) || Util.isNull(data.version)) {
        window.history.pushState({}, '', Config.api.static + location.hash);
    } else {
        window.history.pushState({}, '', `${Config.api.static}/${data.base_id}/${data.version}${location.hash}`);
    }
}

$(() => {
    MasterData.promise.then(load);
    $('.js--save').on('click', save);
});

export default {
    serialize,
    updateURL,
    save
}
